import { render } from "./Actions.vue?vue&type=template&id=31609d7c&scoped=true&lang=pug"
import script from "./Actions.vue?vue&type=script&lang=ts"
export * from "./Actions.vue?vue&type=script&lang=ts"

import "./Actions.vue?vue&type=style&index=0&id=31609d7c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31609d7c"

export default script